module.exports = "<div class=switch> <div class=onoffswitch ng-class=\"{ true :'sw-disable'   , false :''  }[swDisable]\"> <input ng-disabled=swDisable type=checkbox name=switcher class=onoffswitch-checkbox id={{hash_id}} ng-model=onoff ng-change=switchChange()> <label class=onoffswitch-label for={{hash_id}}> <span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span> </label> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/switcher/switcher.html
// module id = bfAG
// module chunks = 0